import { render, staticRenderFns } from "./fixedAdEl.vue?vue&type=template&id=ec34d3a4&"
import script from "./fixedAdEl.vue?vue&type=script&lang=js&"
export * from "./fixedAdEl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('ec34d3a4', component.options)
    } else {
      api.reload('ec34d3a4', component.options)
    }
    module.hot.accept("./fixedAdEl.vue?vue&type=template&id=ec34d3a4&", function () {
      api.rerender('ec34d3a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Pages/page-part/fixedAdEl.vue"
export default component.exports